package one.healthium.profile.navigation.update_age

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.profile.ui.update_age.UpdateAgeScreen

@Composable
fun UpdateAgeContent(component: UpdateAgeComponent) {
    CompositionLocalProvider(
        LocalViewModelStoreOwner provides component
    ) {
        UpdateAgeScreen(component)
    }
}